var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-box",style:({display: _vm.message.isOpened ? 'none' : 'block'})},[(_vm.message.unit)?_c('unit-image',{staticClass:"unit-image",attrs:{"unitType":_vm.message.unit.template.type,"season":'default'}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dialog-box-label"},[_vm._v(_vm._s(_vm.message.title))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7598b8a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/DialogBox.vue
// module id = null
// module chunks = 